import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
//import DataSection from "../components/DataSection";
const Homepage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const searchQuery = searchParams.get("q");

  // Handle search query parameter if present
  useEffect(() => {
    if (searchQuery) {
      // Store the search term in localStorage
      localStorage.setItem("searchTerm", searchQuery);
      
      // Dispatch the custom event to trigger the search in Hero component
      window.dispatchEvent(
        new CustomEvent('searchTermChanged', { 
          detail: { searchTerm: searchQuery } 
        })
      );
    }
  }, [searchQuery]);

  return (
    <div className="App" style={{ backgroundColor: "black", height: "100vh", overflow: "hidden" }}>
      <Navbar />
      <Hero imageId={id} />
    </div>
  );
};

export default Homepage;
